import { Injectable } from '@angular/core';
import type { EventoAbility } from '../eventos.ability';

type RegrasDaAbility = EventoAbility['rules'];

/**
 * O guard RESOLVE a ability; a tela PUBLICA.
 *
 * Publicar direto do guard não funciona nesta rota: o Angular destrói a rota
 * anterior DEPOIS de rodar os guards, e o `ngOnDestroy` do
 * `eventos-insert-edit` faz `ability.update([])`. Vindo pelo botão
 * "Experimentar a tela nova", a publicação do guard era apagada no caminho e a
 * sidebar nascia sem um único item — só um F5 consertava, porque aí não havia
 * tela anterior para destruir.
 *
 * Guardar as regras aqui e publicá-las no `ngOnInit` da tela coloca a
 * publicação DEPOIS do destroy, que é a única ordem que serve aos dois
 * caminhos de entrada.
 */
@Injectable({ providedIn: 'root' })
export class CheckinAbilityHandoff {
  private regras: RegrasDaAbility = [];

  guardar(regras: RegrasDaAbility): void {
    this.regras = regras;
  }

  /** Devolve e esvazia: as regras são de UM evento, não valem para o próximo. */
  consumir(): RegrasDaAbility {
    const atuais = this.regras;
    this.regras = [];
    return atuais;
  }
}
